import { Personal } from '../types';

export const personalData: Personal = {
  name: "Felix Amoruwa",
  title: "Product Leader, Adjunct Faculty, Pilot, Realtor ®, Investor/Day Trader",
  email: "famoruwa@berkeley.edu",
  location: "San Francisco Bay Area, CA US",
  website: "https://www.felixamoruwa.info",
  bio: `Felix Amoruwa is a distinguished Product Leader and Adjunct Faculty member with a strong foundation in computational engineering and business leadership. He holds a Bachelor's of Science degree in Computational Engineering Science from the University of California, Berkeley, where he also earned a Master's Certificate in Corporate Finance for Financial Engineers from the prestigious Haas School of Business.

His academic journey continued at Carnegie Mellon University, where he completed an MBA from the Tepper School of Business and is scheduled to complete a Master of Science in Software Management in May 2016.


Felix's expertise spans multiple cutting-edge domains:
- Computational Engineering Science – Advanced mathematical modeling and simulation
- Electrical & Computer Engineering – Hardware and software systems integration
- Artificial Intelligence & Machine Learning – Neural networks, predictive modeling, and intelligent systems
- Computational Forecasting & Optimization – Mathematical optimization and forecasting algorithms
- Numerical Analysis & Linear Programming – Advanced mathematical computation methods
- Software Architecture & Development – Full-stack development and system design
- Data Structures & Mining – Big data processing and analytics


Beyond his technical expertise, Felix is also a licensed pilot, realtor, and active investor/day trader, demonstrating his versatility across technology, aviation, real estate, and financial markets.`.replace(/\n-/g, '\n\n-'),
  education: [
    {
      degree: "MBA Finance, Economics, Quantitative Analysis",
      institution: "Carnegie Mellon University - Tepper School of Business",
      year: "2009-2012",
      image: "/assets/images/cmu.jpeg"
    },
    {
      degree: "MSc Software Management",
      institution: "Carnegie Mellon University",
      year: "2014-2015",
      image: "/assets/images/cmu.jpeg"
    },
    {
      degree: "Cert. Corporate Finance for Financial Engineers",
      institution: "University of California, Berkeley - Haas School of Business",
      year: "2006",
      image: "/assets/images/berkeley.jpeg"
    },
    {
      degree: "BSc Computational Engineering Science",
      institution: "University of California, Berkeley",
      year: "2001-2005",
      image: "/assets/images/berkeley.jpeg"
    }
  ],
  certifications: [
    {
      name: "Private",
      issuer: "Federal Aviation Administration (FAA)",
      year: "2016",
      status: "completed"
    },
    {
      name: "Drone (Remote Pilot)",
      issuer: "Federal Aviation Administration (FAA)",
      year: "2016",
      status: "completed"
    },
    {
      name: "IFR",
      issuer: "Federal Aviation Administration (FAA)",
      year: "In Progress",
      status: "pending"
    },
    {
      name: "Commercial",
      issuer: "Federal Aviation Administration (FAA)",
      year: "In Progress",
      status: "pending"
    },
    {
      name: "Multi",
      issuer: "Federal Aviation Administration (FAA)",
      year: "In Progress",
      status: "pending"
    },
    {
      name: "CFI",
      issuer: "Federal Aviation Administration (FAA)",
      year: "In Progress",
      status: "pending"
    }
  ],
  languages: [
    {
      name: "English",
      level: "native",
      stars: 5
    },
    {
      name: "Spanish",
      level: "basic",
      stars: 2.5
    },
    {
      name: "French",
      level: "basic",
      stars: 2.5
    },
    {
      name: "Mandarin",
      level: "basic",
      stars: 2.5
    }
  ],
  hobbies: [
    "Aviation",
    "Mobile App Development",
    "Jazz/Classical Saxophone",
    "Golf",
    "Auto Racing",
    "Snowboarding",
    "Cycling",
    "Marathon/Triathlon"
  ],
  social: [
    {
      platform: "Twitter",
      url: "https://twitter.com/Felix_Amoruwa",
      icon: "twitter"
    },
    {
      platform: "LinkedIn",
      url: "https://www.linkedin.com/in/felixamoruwa",
      icon: "linkedin"
    },
    {
      platform: "GitHub",
      url: "https://github.com/famoruwa",
      icon: "github"
    },
    {
      platform: "Hacker News",
      url: "https://news.ycombinator.com/user?id=oamoruwa",
      icon: "hacker-news"
    }
  ]
}; 